import React from "react";

function CareerAboutPage() {
  return <div>careeraboutpage</div>;
}

export default CareerAboutPage;
